import { render, staticRenderFns } from "./ReportPersonnelVsManagementChart.vue?vue&type=template&id=b858e94c&scoped=true&"
import script from "./ReportPersonnelVsManagementChart.vue?vue&type=script&lang=js&"
export * from "./ReportPersonnelVsManagementChart.vue?vue&type=script&lang=js&"
import style0 from "./ReportPersonnelVsManagementChart.vue?vue&type=style&index=0&id=b858e94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b858e94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VRow,VTooltip})
